import React, {useState} from "react";
import {Button} from "@mui/material";
import {Grid} from "@mui/system";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useDispatch, useSelector} from "react-redux";
import style from "../../assets/css/proposal.module.scss";
import {selectUiState, setUiData} from "../../store/uiSlice";
import GlobalModal from "../global-fields/GlobalModal";
import GlobalTextField from "../global-fields/GlobalTextField";
import GlobalSelectField from "../global-fields/GlobalSelectField";
import {selectDataStoreState, setDataStore} from "../../store/dataSlice";
import {selectAuthState} from "../../store/authSlice";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {PAYMENT} from "../../constants/apiConstant";
import {removeCookies} from "../../constants/helper";
import {ERR_MESSAGE} from "../../constants/constants";
import {useNavigate} from "react-router-dom";
import {MdOutlineGppGood} from "react-icons/md";

const CurrentYear = new Date().getFullYear();

const MonthsMenuItems = Array.from({length: 12}, (_, ind) => ({
  name: ind + 1,
  value: ind + 1,
}));

const YearMenuItems = Array.from({length: 50}, (_, ind) => ({
  name: CurrentYear + ind,
  value: CurrentYear + ind,
}));

const PaymentModal = ({fetchSubmittedPro}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user} = useSelector(selectAuthState);
  const {cardnoxModal} = useSelector(selectUiState);
  const {checkoutData} = useSelector(selectDataStoreState);
  const [transactionID, setTransactionID] = useState(false);
  const handlePaymentClose = () => {
    setTransactionID(null);
    formik.resetForm();
    dispatch(
      setDataStore({
        checkoutData: null,
      })
    );
    dispatch(setUiData({cardnoxModal: false}));
  };
  const formik = useFormik({
    initialValues: {
      card_name: "",
      card_number: "",
      card_exp_month: "",
      card_exp_year: "",
      cvv: "",
    },
    validationSchema: Yup.object({
      card_name: Yup.string().required("Card name is required"),
      card_number: Yup.number()
        .typeError("Must be a number")
        .required("Card number is required"),
      card_exp_month: Yup.number()
        .typeError("Must be a number")
        .min(1, "Invalid month")
        .max(12, "Invalid month")
        .required("Month is required"),
      card_exp_year: Yup.number()
        .typeError("Must be a number")
        .min(CurrentYear, "Invalid year")
        .required("Year is required"),
      cvv: Yup.string()
        .matches(/^\d{3,4}$/, "CVV must be 3 or 4 digits")
        .typeError("Must be a number")
        .required("CVV is required"),
    }),
    onSubmit: async (values, {resetForm}) => {
      dispatch(setUiData({showLoader: true}));
      let data = {
        ...values,
        user_id: user?.id,
        proposal_id: checkoutData?.proposal_id,
      };
      // console.log("Payment Details:", data);
      // dispatch(setUiData({ showLoader: false }));
      // return;
      try {
        const response = await fetch(PAYMENT.url, {
          method: PAYMENT.method,
          headers: PAYMENT.headers,
          body: JSON.stringify(data),
        });

        const res = await response.json();

        dispatch(setUiData({showLoader: false}));

        if (res.status == 1) {
          GlobalNotificationPopup({type: "success", message: res?.message});
          setTransactionID(res?.data?.transaction_id ?? null);
          resetForm();
          handlePaymentClose();
          fetchSubmittedPro();
        } else {
          GlobalNotificationPopup({type: "error", message: res?.message});
        }
      } catch (error) {
        console.error("Error:", error);
        removeCookies("isLogin");
        dispatch(setUiData({showLoader: false}));
        GlobalNotificationPopup({
          type: "error",
          message: ERR_MESSAGE,
        });
        navigate("/");
      }
    },
  });
  //console.log("checkoutData", checkoutData);

  return (
    <GlobalModal
      open={cardnoxModal}
      maxWidth="sm"
      handleClose={() => {
        handlePaymentClose();
      }}
      title={transactionID ? "Payment Status" : "Enter Card Details"}
      dialogTitleClass={style.claimPopTitle}
      dialogContent={
        <Grid container spacing={2}>
          {transactionID ? (
            <>
              <Grid size={{xs: 12, md: 12}} sx={{textAlign: "center"}}>
                <MdOutlineGppGood color="#004F71" size={150} />
              </Grid>
              <Grid size={{xs: 12, md: 12}} sx={{textAlign: "center"}}>
                <span> Payment Completed Successfully</span>
                <br />
                <span> Transaction ID : {transactionID}</span>
              </Grid>
            </>
          ) : (
            <>
              <Grid size={{xs: 12, md: 12}} sx={{textAlign: "center"}}>
                <span> Proposal Number : {checkoutData?.proposal_id}</span>
              </Grid>
              <Grid size={{xs: 12, md: 12}} sx={{textAlign: "center"}}>
                <GlobalTextField
                  placeH="Card Name"
                  type="text"
                  name="card_name"
                  id="_card_name"
                  value={formik.values.card_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.card_name && Boolean(formik.errors.card_name)
                  }
                  helperText={
                    formik.touched.card_name && formik.errors.card_name
                  }
                />
              </Grid>
              <Grid size={{xs: 12, md: 12}} sx={{textAlign: "center"}}>
                <GlobalTextField
                  placeH="Card Number"
                  type="number"
                  name="card_number"
                  id="_card_number"
                  value={formik.values.card_number}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.card_number &&
                    Boolean(formik.errors.card_number)
                  }
                  helperText={
                    formik.touched.card_number && formik.errors.card_number
                  }
                />
              </Grid>
              <Grid size={{xs: 12, md: 4}}>
                <GlobalSelectField
                  value={formik.values.card_exp_month}
                  onChange={(e) =>
                    formik.setFieldValue("card_exp_month", e.target.value)
                  }
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.card_exp_month &&
                    Boolean(formik.errors.card_exp_month)
                  }
                  helperText={
                    formik.touched.card_exp_month &&
                    formik.errors.card_exp_month
                  }
                  placeH="Month"
                  menuItems={MonthsMenuItems}
                />
              </Grid>
              <Grid size={{xs: 12, md: 4}}>
                <GlobalSelectField
                  value={formik.values.card_exp_year}
                  onChange={(e) =>
                    formik.setFieldValue("card_exp_year", e.target.value)
                  }
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.card_exp_year &&
                    Boolean(formik.errors.card_exp_year)
                  }
                  helperText={
                    formik.touched.card_exp_year && formik.errors.card_exp_year
                  }
                  placeH="Year"
                  menuItems={YearMenuItems}
                />
              </Grid>
              <Grid size={{xs: 12, md: 4}}>
                <GlobalTextField
                  placeH="CVV"
                  type="number"
                  name="cvv"
                  id="_cvv"
                  value={formik.values.cvv}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.cvv && Boolean(formik.errors.cvv)}
                  helperText={formik.touched.cvv && formik.errors.cvv}
                />
              </Grid>
              <Grid size={{xs: 12, md: 12}} sx={{textAlign: "center"}}>
                <Button
                  variant="contained"
                  onClick={formik.handleSubmit}
                  style={{padding: 5, fontSize: 18, letterSpacing: 1}}
                  fullWidth
                >
                  Pay{" "}
                  {checkoutData?.formated_hard_quote
                    ? checkoutData?.formated_hard_quote
                    : null}
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      }
    />
  );
};

export default PaymentModal;
